import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LinkInformation } from '../interfaces/linkinformation.interface';

@Injectable({
  providedIn: 'root'
})
export class LinkInformationService {
  readonly url: string = 'linkInformation';

	constructor(private http: HttpClient) {}

	public getAll(): Observable<LinkInformation[]> {
		return this.http.get<LinkInformation[]>(this.url);
	}

  public updateSingle(entity: LinkInformation): Observable<boolean> {
    return this.http.patch<boolean>(this.url, entity)
  }

  public updateMultipleSortingIndex(entities: LinkInformation[]): Observable<boolean> {
    return this.http.patch<boolean>(this.url + '/' + 'updateMultipleSortingIndex', entities)
  }
}
